import { Instance } from 'mobx-state-tree';
import { ProjectUpdatedDtoModelBase } from './ProjectUpdatedDtoModel.base';

/* The TypeScript type of an instance of ProjectUpdatedDtoModel */
export interface ProjectUpdatedDtoModelType extends Instance<typeof ProjectUpdatedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectUpdatedDtoModel */
export { selectFromProjectUpdatedDto, projectUpdatedDtoModelPrimitives, ProjectUpdatedDtoModelSelector } from './ProjectUpdatedDtoModel.base';

/**
 * ProjectUpdatedDtoModel
 */
export const ProjectUpdatedDtoModel = ProjectUpdatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
